import { h, Component } from 'preact';
import HTML from 'components/core/html/html';
import Button from 'components/shared/button/button';
import s from 'components/pages/hub/signup.sss';
import Store from 'store/store';
import * as actions from 'store/actions';

export default class Signup extends Component {
	render({ data, client }) {
		const {
			title  = '',
			blurb  = '',
			button = {},
			icon   = {}
		} = data;

		return (
			<aside class={s.container}>
				<img class={s.icon} src={icon.src} alt={icon.alt} />
				<div class={s.info}>
					<HTML class={s.title} tag='h3' markdown>{title}</HTML>
					<HTML class={s.blurb} tag='p' markdown>{blurb}</HTML>
				</div>
				<Button data={button} client={client} extraOnClick={() => {Store.emit(actions.POWSTER_GA_EVENT_TRACK, 'static', 'signup', Store.get().activePage.id + '_' + 'signup');}}/>
			</aside>
		);
	}
}
